import { render, staticRenderFns } from "./ShapeEditingModal2.vue?vue&type=template&id=aca4c256&scoped=true&"
import script from "./ShapeEditingModal2.vue?vue&type=script&lang=ts&"
export * from "./ShapeEditingModal2.vue?vue&type=script&lang=ts&"
import style0 from "./ShapeEditingModal2.vue?vue&type=style&index=0&id=aca4c256&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca4c256",
  null
  
)

export default component.exports